import React, { Component } from 'react'

export default class Footer extends Component {
    render() {
        return (
            <div>
                <footer className="ftco-footer ftco-bg-dark ftco-section">
                    <div className="container">
                        <div className="row mb-5 justify-content-center">
                            <div className="col-md-5 text-center">
                                <div className="ftco-footer-widget mb-5">
                                    <ul className="ftco-footer-social list-unstyled mt-4">
                                        <li><a rel="noopener noreferrer" target="_blank" href="https://github.com/alfecaesar"><span className="icon-github"></span></a></li>
                                        <li><a rel="noopener noreferrer" target="_blank" href="https://codepen.io/alfecaesar/"><span className="icon-codepen"></span></a></li>
                                        <li><a rel="noopener noreferrer" target="_blank" href="https://www.linkedin.com/in/alfe-caesar-lagas-24663535/"><span className="icon-linkedin"></span></a></li>
                                        <li><a rel="noopener noreferrer" target="_blank" href="https://facebook.com/alfecaesar"><span className="icon-facebook"></span></a></li>
                                        <li><a href="mailto:alfecaesar@gmail.com"><span className="icon-mail_outline"></span></a></li>
                                    </ul>
                                </div>
                                <div className="ftco-footer-widget">
                                    <h2 className="mb-3">Hire Alfe</h2>
                                    <p className="h3 email"><a rel="noopener noreferrer" target="_blank" href="https://www.dropbox.com/s/rnd4gkxk1hao3ny/Alfe%20Caesar%20Lagas%20-%20CV%202.pdf?dl=0">Download CV</a></p>
                                </div>
                            </div>
                        </div>

                    </div>
                </footer>
            </div>
        )
    }
}